import { createReducer, createTypes } from 'reduxsauce';
import { historicKey } from '../../../utils';

export const historicTypes = createTypes(
  `
      SET_VARIABLE
      SET_LOADING
      RESET
      RESET_HISTORIC
  `,
  { prefix: 'HISTORIC/' }
);

const INITIAL_STATE = {};

// Reducers
// Merge-aware: aceita acoes parciais (so data, so ranges, ou ambos).
// Antes a saga so dispatchava quando data + ranges chegavam, deixando o
// grafico esperando o request mais lento. Agora a saga dispatcha 2x e
// o reducer preserva o campo que nao veio nessa acao.
const setVariable = (state = INITIAL_STATE, action) => {
  // Chave composta thingId+variavel — isola o cache por maquina (ver
  // historicKey). action.thingId vem da saga.
  const key = historicKey(action.thingId, action.variable);
  const prev = state[key] || {};
  const next = { ...prev };
  if (action.data !== undefined) {
    next[action.period] = action.data;
  }
  if (action.ranges !== undefined) {
    next.ranges = action.ranges;
  }
  return {
    ...state,
    [key]: next,
  };
};

const resetHistoric = () => {
  return {};
};

const setLoading = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    loading: action.loading,
  };
};

const reset = () => {
  return INITIAL_STATE;
};

export default createReducer(INITIAL_STATE, {
  [historicTypes.SET_VARIABLE]: setVariable,
  [historicTypes.SET_LOADING]: setLoading,
  [historicTypes.RESET]: reset,
  [historicTypes.RESET_HISTORIC]: resetHistoric,
});
